import { message } from 'antd';

/**
 * Convert a JSON object to CSV format
 * @param data Array of objects to convert to CSV
 * @param headers Array of header keys to include in the CSV
 * @returns CSV string
 */
export const convertToCSV = (data: any[], headers: string[]): string => {
    if (!data || data.length === 0) {
        return '';
    }
    const headerRow = headers.join(',');

    const rows = data.map((item) => {
        return headers.map((header) => {
            // Handle nested properties with dot notation (e.g., "user.name")
            const value = header?.split('.')?.reduce((obj, key) => obj && obj[key], item);
            let formattedValue = value === null || value === undefined ? '' : String(value);

            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (formattedValue.includes(',') || formattedValue.includes('\n') || formattedValue.includes('"')) {
                formattedValue = `"${formattedValue.replace(/"/g, '""')}"`;
            }

            return formattedValue;
        }).join(',');
    });
    return [headerRow, ...rows].join('\n');
};

/**
 * Create and download a CSV file from JSON data
 * @param data Array of objects to convert to CSV
 * @param filename Name of the file to download
 * @param headers Array of header keys to include in the CSV
 */
export const createAndDownloadCSVFileFromJSON = (
    data: any[],
    filename: string,
    headers: string[],
): void => {
    if (!data || data.length === 0) {
        message.warning('No data to download');
        return;
    }
    const csv = convertToCSV(data, headers);

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    // Set link properties
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
